var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.21 9.21L12.21 7.93C12.21 7.75 12.15 7.6 12.02 7.48 11.9 7.35 11.75 7.29 11.57 7.29L3.86 7.29C3.68 7.29 3.53 7.35 3.41 7.48 3.28 7.6 3.21 7.75 3.21 7.93L3.21 9.21C3.21 9.39 3.28 9.54 3.41 9.67 3.53 9.79 3.68 9.86 3.86 9.86L11.57 9.86C11.75 9.86 11.9 9.79 12.02 9.67 12.15 9.54 12.21 9.39 12.21 9.21ZM15.43 8.57C15.43 9.97 15.08 11.26 14.39 12.44 13.7 13.63 12.77 14.56 11.59 15.25 10.4 15.94 9.11 16.29 7.71 16.29 6.31 16.29 5.02 15.94 3.84 15.25 2.66 14.56 1.72 13.63 1.03 12.44 0.34 11.26 0 9.97 0 8.57 0 7.17 0.34 5.88 1.03 4.7 1.72 3.52 2.66 2.58 3.84 1.89 5.02 1.2 6.31 0.86 7.71 0.86 9.11 0.86 10.4 1.2 11.59 1.89 12.77 2.58 13.7 3.52 14.39 4.7 15.08 5.88 15.43 7.17 15.43 8.57Z"}));
}

Minus.defaultProps = {"viewBox":"0 0 16 17"};

module.exports = Minus;

Minus.default = Minus;
